import { TextDocumentIcon } from "@fluentui/react-icons-mdl2";

import { Tariff } from "../../interfaces/invoices-response";

import { TariffContainer, TariffContent, TariffName } from "./style";

import { formatPhoneAndSerialNumberMask } from "@/utils/PhoneAndSerialNumberMask/formatPhoneAndSerialNumber";

interface TariffItemProps {
  tariff: Tariff;
  selected: boolean;
  onClick: (tariff: Tariff) => void;
}

export default function TariffItem({
  tariff,
  selected,
  onClick
}: TariffItemProps) {
  return (
    <TariffContainer selected={selected} onClick={() => onClick(tariff)}>
      <TariffContent>
        {tariff &&
          (tariff.identifier ? (
            <>
              <TextDocumentIcon />
              <TariffName>
                {formatPhoneAndSerialNumberMask(tariff.identifier)}
              </TariffName>
            </>
          ) : (
            <TariffName>{tariff.id}</TariffName>
          ))}
      </TariffContent>
    </TariffContainer>
  );
}
